<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn
                v-if="can('create', 'course')"
                small
                color="primary"
                @click="sendEmit('create')"
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="_id"
                :pagination.sync="pagination"
                :loading="loading"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center px-0">
                    <v-btn
                      v-if="can('create', 'course')"
                      flat
                      icon
                      color="primary"
                      class="px-0 mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('clone', props.item._id)"
                      >file_copy</v-icon>
                    </v-btn>
                    <v-btn flat icon color="primary" class="px-0 mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('view', props.item._id)"
                      >visibility</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('edit', 'course',  props.item)"
                      flat
                      icon
                      color="success"
                      class="px-0 mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >create</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('delete', 'course',  props.item)"
                      flat
                      icon
                      color="error"
                      class="px-0 mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('delete', props.item._id)"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td>{{props.item.name}}</td>
                  <td class="text-xs-center">{{props.item.createdAt}}</td>
                  <td>{{props.item.createdBy}}</td>
                  <td class="text-xs-center">{{props.item.updatedAt}}</td>
                  <td>{{props.item.updatedBy}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirme Clonacion</v-card-title>

        <v-card-text>¿Realmente desea clonar este curso?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" flat="flat" @click="yesClone()">Confirmar</v-btn>

          <v-btn color="error darken-1" flat="flat" @click="noClone()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'

export default {
  name: 'list',
  data() {
    return {
      isClone: null,
      search: '',
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            align: 'center',
            value: ''
          },
          {
            text: this.$t('state'),
            align: 'center',
            value: 'active'
          },
          {
            text: this.$t('name'),
            value: 'name'
          },
          {
            text: this.$t('createdAt'),
            align: 'center',
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            align: 'center',
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            align: 'center',
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            align: 'center',
            value: 'updatedBy'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.courses.loading,
      listCourses: state => state.courses.list,
      listUser: state => state.users.listaUsers,
      listTournaments: state => state.tournaments.list,
      interCourse: state => state.courses.selected
    }),
    formatList() {
      return this.listCourses.map(course => {
        return {
          ...course,
          createdAt: dateFormat(course.createdAt, false),
          updatedAt: dateFormat(course.updatedAt, false)
        }
      })
    },
    dialog() {
      return this.isClone !== null
    }
  },
  methods: {
    ...mapActions({
      getOne: 'courses/setOne',
      setClone: 'courses/setClone'
    }),
    sendEmit(evento, id = null) {
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id).then(_ => {
            this.$emit('update')
          })
          break
        case 'delete':
          this.getOne(id).then(_ => {
            this.$emit('remove')
          })
          break
        case 'view':
          this.getOne(id).then(_ => {
            this.$emit('view')
          })
          break
        case 'clone':
          this.getOne(id).then(_ => {
            this.isClone = id
          })
          break
      }
    },
    formatTournament(id) {
      return this.listTournaments.find(item => item._id === id) || 'Sin datos'
    },
    resolveContent(content) {
      console.log(content)
      let result = ''
      let temporal = null
      switch (this.$i18n.locale) {
        case 'en':
          temporal = content.find(
            item => item.langId === '5bd9f3ee7fa5610014fed21f'
          )
          if (temporal) {
            result = temporal.text
          }
          break
        case 'es':
          temporal = content.find(
            item => item.langId === '5bd9f3ee7fa5610014fed21e'
          )
          if (temporal) {
            result = temporal.text
          }
          break
        case 'ca':
          temporal = content.find(
            item => item.langId === '5c8011ee80c7daaa57123a68'
          )
          if (temporal) {
            result = temporal.text
          }
          break
      }
      const points = result.length > 40 ? ' ...' : ''
      return result.substring(0, 40) + points
    },
    noClone() {
      this.isClone = null
    },
    yesClone() {
      if (this.isClone) {
        this.setClone(this.interCourse)
      }
      this.isClone = null
    }
  }
}
</script>

<style scoped>
.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
